import { CustomLoader, LoaderContainer } from './Style';

interface LoaderProps {
    loading: boolean;
}

const Loader = ({ loading = false }: LoaderProps) => {
    const isLoading = loading;

    return isLoading ? (
        <LoaderContainer>
            <CustomLoader color='#3636B9' loading={isLoading} size={50} />
        </LoaderContainer>
    ) : (
        <></>
    );
};

export default Loader;
